import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Waypoint = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Waypoint" {...props}>
    <path d="M20.5939 2.08569C20.972 1.91776 21.4147 2.0002 21.7072 2.29272C21.9997 2.58526 22.0821 3.02794 21.9142 3.40601L13.9142 21.406C13.7409 21.796 13.3384 22.0327 12.9132 21.9958C12.4882 21.9588 12.1339 21.6559 12.0304 21.2419L10.1759 13.824L2.75797 11.9695C2.34403 11.866 2.04114 11.5117 2.00406 11.0867C1.9672 10.6615 2.20393 10.259 2.5939 10.0857L20.5939 2.08569ZM6.05972 10.7341L11.2423 12.03L11.3732 12.072C11.6679 12.1905 11.8915 12.4442 11.9699 12.7576L13.2648 17.9392L19.0294 4.96948L6.05972 10.7341Z" fill="#000" />
  </StyledIcon>
));

Waypoint.displayName = 'Waypoint';

export { Waypoint };
